'use client';
import Image from 'next/image';

const speakers = [
  {
    name: "Evan Szu",
    designation: "Founder & CEO",
    company: "Gamma Prime",
    imageSrc: "/images/speakers/evan-szu.webp",
    alt: "Pauline-Shangett-Chief-Strategy-Officer-at-ChangeNOW",  
  },
  {
    name: "Alex Buelau",
    designation: "Co-founder & CPTO",
    company: "Parfin",
    imageSrc: "/images/speakers/alex.webp",
    alt: "shamir",
  },
  {
    name: "Mitchell Williams",
    designation: "CFA, CIO",
    company: "Streamex",
    imageSrc: "/images/speakers/mitchell.webp",
    alt: "mitchell-williams",
  },
  {
    name: "Danielle	Marie",
    designation: "Founder",
    company: "EolvH3R",
    imageSrc: "/images/speakers/danielle-marie.webp",
    alt: "danielle-marie",
  },
  {
    name: "Mohamed Khaled",
    designation: "Founder",
    company: "Hotdesk",
    imageSrc: "/images/speakers/mohamed.webp",
    alt: "henrymcphie",
  },
  {
    name: "Eljaboom",
    designation: "14 Years in Crypto/Advisor ",
    company: "",
    imageSrc: "/images/speakers/eljaboom.webp",
    alt: "eljaboom",
  },
  // end of teh 2025 speakers
  {
    name: "Pauline Shangett",
    designation: "Chief Strategy Officer",
    company: "ChangeNOW",
    imageSrc: "/images/speakers/pauline-pic.webp",
    alt: "Pauline-Shangett",  
  },
  {
    name: "Diego Martin",
    designation: "CEO",
    company: "Yellow Capital",
    imageSrc: "/images/speakers/diego-martin.webp",
    alt: "DiegoMartin",  // Improved
  },
  {
    name: "Andy Ting",
    designation: "Founder",
    company: "HeLa Labs",
    imageSrc: "/images/speakers/andy-ting.webp",
    alt: "Andy-Ting",
  },{
    name: "Edwin Mata",
    designation: "CEO",
    company: "Brickken",
    imageSrc: "/images/speakers/edwinMata.webp",
    alt: "Edwin-Mata",
  },{
    name: "Anna Tutova",
    designation: "CEO",
    company: "Coins Telegram",
    imageSrc: "/images/speakers/annatutova.webp",
    alt: "annatutova",
  },
  {
    name: "Laura K. Inamedinova",
    designation: "Cheif Ecosystem Officer",
    company: "Gate ecosystem / GVC",
    imageSrc: "/images/speakers/laura.webp",
    alt: "Laura-K",
  },
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.tsx:92:4" data-component-path="src/app/SpeakerSection.tsx" data-component-line="92" data-component-file="SpeakerSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20bg-white%20items-center%20justify-center%22%7D" id='speakers'
           className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] bg-white items-center justify-center" >
       <div data-component-id="src/app/SpeakerSection.tsx:94:7" data-component-path="src/app/SpeakerSection.tsx" data-component-line="94" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
              <h2 data-component-id="src/app/SpeakerSection.tsx:95:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="95" data-component-file="SpeakerSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B28px%5D%20text-center%20mb-10%20sm%3Atext-%5B36px%5D%20md%3Atext-%5B46px%5D%20lg%3Atext-%5B56px%5D%20font-bold%20font-satoshi%20leading-tight%20bg-gradient-to-b%20from-black%20to-gray-500%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[28px] text-center mb-10 sm:text-[36px] md:text-[46px] lg:text-[56px] font-bold font-satoshi leading-tight bg-gradient-to-b from-black to-gray-500 bg-clip-text text-transparent">
                Past Speakers
              </h2>
              {/* Speaker List Box */}
              <div data-component-id="src/app/SpeakerSection.tsx:99:14" data-component-path="src/app/SpeakerSection.tsx" data-component-line="99" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full max-w-[1200px] mx-auto">
                {/* <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 gap-y-8 sm:gap-3 place-items-center">  */}
                <div data-component-id="src/app/SpeakerSection.tsx:101:16" data-component-path="src/app/SpeakerSection.tsx" data-component-line="101" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-center%20gap-5%20sm%3Agap-10%22%7D" className="flex flex-wrap justify-center gap-5 sm:gap-10">
                  {speakers.map((speaker) => (  
                    <div data-component-id="src/app/SpeakerSection.tsx:103:20" data-component-path="src/app/SpeakerSection.tsx" data-component-line="103" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20bg-%5B%230000001a%5D%20p-3%20rounded-%5B10px%5D%20%22%7D" key={speaker.name} className="flex flex-col items-center bg-[#0000001a] p-3 rounded-[10px] ">  
                      {/* Image Container */}
                      <div data-component-id="src/app/SpeakerSection.tsx:105:22" data-component-path="src/app/SpeakerSection.tsx" data-component-line="105" data-component-file="SpeakerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B200px%5D%20sm%3Ah-%5B200px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] relative mb-4">  
                        <Image data-component-id="src/app/SpeakerSection.tsx:106:24" data-component-path="src/app/SpeakerSection.tsx" data-component-line="106" data-component-file="SpeakerSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%22%7D"
                          src={speaker.imageSrc}
                          alt={speaker.alt}
                          height={200}
                          width={200}
                          className="object-cover"
                          unoptimized
                        />
                      </div>
      
                      <h3 data-component-id="src/app/SpeakerSection.tsx:116:22" data-component-path="src/app/SpeakerSection.tsx" data-component-line="116" data-component-file="SpeakerSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23ff00b6%5D%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#ff00b6] text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                        {speaker.name}
                      </h3>
                      <p data-component-id="src/app/SpeakerSection.tsx:119:22" data-component-path="src/app/SpeakerSection.tsx" data-component-line="119" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%231816ff%5D%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-[#1816ff] text-[12px] sm:text-[14px] text-center mb-1">
                        {speaker.designation}
                      </p>
                      <p data-component-id="src/app/SpeakerSection.tsx:122:22" data-component-path="src/app/SpeakerSection.tsx" data-component-line="122" data-component-file="SpeakerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%23000%5D%20text-xs%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-[#000] text-xs sm:text-[12px] text-center"> 
                        {speaker.company}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        );
      };
export default SpeakerSection;
